export function isLastElementOfArray(array: any[], index: number): boolean {
  return index === array.length - 1;
}
